import PropTypes from 'prop-types'
import styles from './NotificationBox.module.css'

const TYPES = ['success', 'error', 'info', 'alert']
const BACKGROUNDS = ['white', 'tinted']

const ICONS = {
  success: 'check_circle',
  error: 'error_outline',
  info: 'info',
  alert: 'report_problem',
}

export function NotificationBox({
  type = 'success',
  background = 'white',
  title,
  description,
  actions,
  onClose,
  className = '',
}) {
  const notificationClasses = [
    styles.notification,
    styles[`notification--${type}`],
    background === 'white' ? styles['notification--white'] : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const bodyClasses = [
    styles.body,
    background === 'white' ? styles['body--white'] : styles['body--tinted'],
    background === 'tinted' ? styles[`body--${type}`] : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={notificationClasses}>
      <div className={[styles.bar, styles[`bar--${type}`]].join(' ')} />
      <div className={bodyClasses}>
        <div className={styles.content}>
          <span className={styles.icon}>
            <span className="material-icons-outlined">{ICONS[type]}</span>
          </span>
          <div className={styles['text-actions']}>
            <div className={styles.texts}>
              <p className={styles.title}>{title}</p>
              {description && <p className={styles.desc}>{description}</p>}
            </div>
            {actions && <div className={styles.actions}>{actions}</div>}
          </div>
        </div>
        {onClose && (
          <button type="button" className={styles.close} aria-label="Cerrar" onClick={onClose}>
            <span className="material-icons-outlined">close</span>
          </button>
        )}
      </div>
    </div>
  )
}

NotificationBox.propTypes = {
  type: PropTypes.oneOf(TYPES),
  background: PropTypes.oneOf(BACKGROUNDS),
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  actions: PropTypes.node,
  onClose: PropTypes.func,
  className: PropTypes.string,
}
